import React, { useState } from 'react';
import { OrderCardProduct } from './dashboard-utils';
import { Typography } from '../../../components/typography/typography';
import { ProductTrackingType } from '../../../clients/quipli-service/product/product';

type ProductTableProps = {
  orderProducts: OrderCardProduct[];
  unitTrackingViaUnitNum?: boolean;
};

export const ProductTable = ({ orderProducts, unitTrackingViaUnitNum = true }: ProductTableProps) => {
  const [expanded, setExpanded] = useState(false);

  const MAX_PRODUCTS = 10;
  const numProducts = orderProducts.length;
  const numOverflow = numProducts - MAX_PRODUCTS;

  return (
    <div className="order-products grid grid-cols-1 rounded-4 overflow-hidden mb-2">
      <div className="order-products-header flex flex-row bg-grey-100 p-2">
        <div style={{ flex: 1 }}></div>
        <div style={{ flex: 6 }}>Product name</div>
        <div style={{ flex: 2 }}>Unit</div>
      </div>

      <div className="overflow-scroll max-h-[25rem]">
        {orderProducts.slice(0, !expanded ? MAX_PRODUCTS : undefined).map((product, index) => (
          <div className="flex flex-row p-2" key={index}>
            <div style={{ flex: 1 }}>
              <Typography type="text-sm">{product.quantity} x</Typography>
            </div>
            <div style={{ flex: 6 }}>
              <Typography type="text-sm" weight="semi-bold">
                {product.name}
              </Typography>
            </div>
            <div style={{ flex: 2 }}>
              <Typography type="text-sm" weight="semi-bold" className={!product.unit ? 'text-error-500' : ''}>
                {product.trackingType === ProductTrackingType.SerialUnits && product.id != 1
                  ? unitTrackingViaUnitNum
                    ? product.unit != undefined
                      ? product.unit
                      : 'Not assigned'
                    : product.serial != undefined
                    ? product.serial
                    : 'Not assigned'
                  : ''}
              </Typography>
            </div>
          </div>
        ))}
      </div>
      {numOverflow > 0 && (
        <div className="flex flex-row p-2" onClick={() => setExpanded((last) => !last)}>
          <div style={{ flex: 1 }} />
          <div style={{ flex: 6 }}>
            <Typography type="text-xs" weight="regular" className="text-quipli-black-500 cursor-pointer">
              {!expanded ? `+ ${numOverflow} items` : '- Less items'}
            </Typography>
          </div>
          <div style={{ flex: 2 }} />
        </div>
      )}
    </div>
  );
};
